
export enum DexaMetric {
	BoneDensity = 'BONE_DENSITY',
	FatPct = 'BODY_FAT_PCT',
	LeanMass = 'LEAN_MASS_INDEX',
	LimbMass = 'ALMI',
	RegionalComp = 'REGIONAL_COMP',
	RmrEstimate = 'RMR_ESTIMATE',
	VisceralFat = 'VAT_MASS',
}

export type DexaGender =
	| 'Male'
	| 'Female'
	;

export type SectionColor =
	| 'green'
	| 'white'
	| 'blue'
;

export type CardText = (
	pct: number,
	reverse: boolean,
	breaks?: number[],
) => React.ReactNode

export type Citation = {
	methodology: string,
	papers: string[],
	disclaimer: string
}

export type Section = {
	color?: SectionColor
	colorSplit?: boolean
	separator?: boolean
	open?: boolean | 'always'
	exclude?: 'voice'

	metric?: DexaMetric
	anchor?: string
	reverse?: boolean

	details: {
		header: {
			title: string,
			summary: string,
		}
		citations?: Citation,
		illustration?: React.ReactNode,
		card?: {
			title: string,
			fmt: (v: number, p: string) => [string, React.ReactNode],
			description: CardText,
		}
		snapshot: {
			chart: {
				hover: string
				marker: string
				xlabel: string
			},
			text: {
				explainer: string,
				metric: string,
				reference: string,
			},
		}
		historical: {
			chart: {
				hover: (min: number, max: number) => string,
				marker: string,
				min?: number,
				ylabel: string,
				yrange?: number[],
				minAge?: number,
				maxAge?: number
			}
			text: {
				explainer: string,
				reference: string,
			}
		}
		table: {
			arrow?: boolean,
			fmt: (value: number) => React.ReactNode,
			heading: string,
			title: string,
		}
		percentiles: {
			label: string,
		},
		footer?: React.ReactNode,
	}
};

export type Configs = {
	header: {
		generated: string
		count: number
		reference: string
		handle?: string
	}
	sections: Section[]
};
